<script lang="ts">
  import { Eye, EyeClosed } from '@lucide/svelte'
  import ColorPicker from '../../color-picker/ColorPicker.svelte'
  import IconButton from '../../icon-button/IconButton.svelte'
  import PaneHead from '../../pane/PaneHead.svelte'
  import type { Snippet } from 'svelte'

  type Props = {
    children?: Snippet
    color?: string
    selected: boolean
    onToggleHidden: () => void
    onColorChange: (color: string) => void
    visible?: boolean
    isEmpty?: boolean
  }

  const {
    children,
    color,
    selected,
    onToggleHidden,
    onColorChange,
    visible,
    isEmpty,
  }: Props = $props()
</script>

<div class="container">
  <PaneHead
    class="head"
    containerClassName="head-container"
    data-selected={selected}
    data-visible={visible}
    empty={isEmpty}
  >
    <div class="head-actions">
      <ColorPicker {color} {onColorChange} />
      {@render children?.()}
    </div>
    <IconButton onclick={onToggleHidden}>
      {#if visible}
        <Eye />
      {:else}
        <EyeClosed />
      {/if}
    </IconButton>
  </PaneHead>
</div>

<style lang="scss">
  .container {
    :global(.head) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    :global(.head[data-visible='false']) {
      filter: opacity(0.5);
    }

    :global(.head-container:has([data-selected='true'])) {
      background-color: var(--printer-pane-active-background);
    }

    .head-actions {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
    }
  }
</style>
